import { createFileRoute } from '@tanstack/react-router';

import { ProposalManagementTab } from '../modules/Analytics/components/tabs/ProposalManagementTab';

export const Route = createFileRoute('/proposals')({
  component: RouteComponent,
  head() {
    return {
      meta: [{ title: 'Proposals' }],
    };
  },
});

function RouteComponent() {
  return (
    <div className="min-h-screen bg-white p-4 md:p-6 lg:p-8">
      <ProposalManagementTab hideKpiCards />
    </div>
  );
}
